export default "__VITE_ASSET__Ccf8eQHi__"